import React from 'react'
import PropTypes from 'prop-types'
import { getAssetInfoLabel } from './utils'
import classnames from 'classnames/bind'
import cls from './styles.scss'
import { getDisplayIndicator, listing as listingUtils } from '../../../utils'

const cx = classnames.bind(cls)

const ListingIndicator = ({
  listing,
  elmId,
  className,
  hideAuctionDate = false,
  hideAuctionType = false,
}) => {
  const productInfo = getDisplayIndicator(listing) || {}

  const eventType = listingUtils.isListingOnline(listing)
    ? 'ONLINE'
    : 'IN PERSON'
  return (
    <div
      className={cx('asset-info', className)}
      data-elm-id={`asset-info-${elmId}`}
    >
      <img
        src={productInfo.iconSvg}
        className={cx('info-dot')}
        alt={productInfo.label}
      />
      <div>
        {getAssetInfoLabel(
          productInfo,
          eventType,
          listing,
          hideAuctionDate,
          hideAuctionType
        )}
      </div>
    </div>
  )
}

ListingIndicator.propTypes = {
  listing: PropTypes.object,
  elmId: PropTypes.string,
  hideAuctionDate: PropTypes.bool,
  hideAuctionType: PropTypes.bool,
  className: PropTypes.string,
}
export default ListingIndicator
